/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Bot_LinkInputs */

const en_site_bot_link = /** @type {(inputs: Site_Bot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About BystepBot`)
};

const id_site_bot_link = /** @type {(inputs: Site_Bot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang BystepBot`)
};

/**
* | output |
* | --- |
* | "About BystepBot" |
*
* @param {Site_Bot_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_bot_link = /** @type {((inputs?: Site_Bot_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Bot_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_bot_link(inputs)
	return en_site_bot_link(inputs)
});